import styled from '@emotion/styled';

import { hexToRgba } from 'src/shared/helpers/hexToRgba';
import { color, font, mediaQueries } from 'src/shared/styles/variables';

interface CircularRatesWrapperProps {
    fullWidth?: boolean;
}

export const CircularRatesWrapper = styled('div')<CircularRatesWrapperProps>(({ fullWidth }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    margin: fullWidth ? '0 auto' : '0',
    width: fullWidth ? '100%' : 'fit-content',
    justifyContent: 'space-between',
    alignItems: 'center',
    [mediaQueries.md]: {
        justifyContent: 'flex-start',
    },
}));

interface CircularRatesLabelProps {
    large?: boolean;
}

export const CircularRatesLabel = styled('div')<CircularRatesLabelProps>(
    ({ large }) => (large ? font.heavy(font.size.mediumExtended) : font.medium(font.size.medium)),
    {
        color: color.scooter,
        maxWidth: '12.25rem',
        textTransform: 'capitalize',
        textAlign: 'center',
        [mediaQueries.md]: {
            display: 'none',
        },
    },
);

export const CircularRates = styled('div')<CircularRatesWrapperProps>(({ fullWidth }) => ({
    display: 'flex',
    padding: fullWidth ? 0 : '0 1.75rem',
    justifyContent: 'center',
    flexGrow: 1,
    flexWrap: 'wrap',
    alignItems: 'center',
    [mediaQueries.sm]: {
        justifyContent: 'center',
    },
}));

export interface CircularRateProps {
    selected?: boolean;
}

export const CircularRate = styled('div')<CircularRateProps>(
    ({ selected }) => ({
        width: '1.97rem',
        height: '1.97rem',
        textAlign: 'center',
        lineHeight: 1,
        marginRight: '0.66rem',
        paddingTop: '0.44rem',
        borderRadius: '100%',
        backgroundColor: selected ? color.scooter : hexToRgba(color.scooter, 0.2),
        color: selected ? color.white : color.scooter,
        cursor: selected ? 'cursor' : 'pointer',
        transition: 'all 0.2s',
        '&:last-child': {
            marginRight: 0,
        },
        '&:hover': {
            backgroundColor: selected ? color.scooter : color.easternBlue,
            color: color.white,
        },
        [mediaQueries.sm]: {
            marginBottom: '0.66rem',
        },
    }),
    font.roman(font.size.large),
);
